/*eslint-disable*/
import React, { useEffect, useState } from "react";
import "./createUser.scss";
import Button from "components/Button/index";

const CreateUser = ({
  handlestep,
  updateUserName,
  updateEmail,
  initialUserName,
  initialEmail
}) => {
  const [userName, setUserName] = useState(initialUserName || "");
  const [email, setEmail] = useState(initialEmail || "");
  const [isValidEmail, setIsValidEmail] = useState(true);

  useEffect(() => {
    setUserName(initialUserName || "");
    setEmail(initialEmail || "");
  }, [initialUserName, initialEmail]);

  // const handleInputChange = (e) => {
  //   setUserName(e.target.value);
  //   updateUserName(e.target.value);
  // };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    updateEmail(value);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setIsValidEmail(emailRegex.test(value));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && email.trim() && isValidEmail) {
      e.preventDefault(); // Prevent form submission or page reload
      handlestep();
    }
  };

  return (
    <div className="createUserContainer">
      <div className="CreateRoleWrapper">
        <div className="CreateRoleWrapperContent">
          <p>Email</p>
          <input
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={handleEmailChange}
            onKeyDown={handleKeyDown}
            autoFocus="true"
            className="CreateRoleWrapperContentInput"
          />
          {!isValidEmail && email.trim() !== "" && (
            <span className="error-message">
              Please enter a valid email address
            </span>
          )}
        </div>
      </div>

      <Button
        type="violet"
        title="Invite"
        onClick={handlestep}
        disabled={!email.trim() || !isValidEmail}
      />
    </div>
  );
};

export default CreateUser;
